export default "__VITE_ASSET__3d691fdd__"